import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import * as Icon from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../../core/data/redux/store';
import {
  createLead,
  updateLead,
  getAllLeads,
} from '../../../../services/leadServices';
import { getAllPartnerUsers } from '../../../../services/partnerServices';
import { getAllProjects } from '../../../../services/projectServices';

import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';

const style = `
  .dropdown-panel {
    z-index: 9999 !important;
  }
  .p-dropdown-panel {
    z-index: 9999 !important;
  }
`;

const LeadsModal = ({
  selectedLead,
  setIsAddModalOpen,
  isAddModalOpen,
  isEditModalOpen,
  setIsEditModalOpen,
}: {
  selectedLead: any | null;
  setIsAddModalOpen: (value: boolean) => void;
  isAddModalOpen: boolean;
  isEditModalOpen: boolean;
  setIsEditModalOpen: (value: boolean) => void;
}) => {
  const toast = useRef<Toast>(null);
  const { leadCreated, leadUpdated, isError, errorMessage } =
    useSelector((state: any) => state.lead);
  const { partnerUsers } = useSelector((state: any) => state.partner);
  const { projects } = useSelector((state: any) => state.project);
  const [partnerOptions, setPartnerOptions] = useState<Array<{ label: string; value: string }>>([]);
  const [projectOptions, setProjectOptions] = useState<Array<{ label: string; value: string }>>([]);
  
  const [lead, setLead] = useState({
    first_name: '',
    last_name: '',
    email_address: '',
    phone_number: '',
    source_type: '',
    partner_id: null as string | null,
    project_id: '',
  });
  const dispatch = useDispatch<AppDispatch>();
  
  const [updatedLead, setUpdatedLead] = useState<any>({
    id: selectedLead?.id || '',
    first_name: selectedLead?.first_name || '',
    last_name: selectedLead?.last_name || '',
    email_address: selectedLead?.email_address || '',
    phone_number: selectedLead?.phone_number || '',
    source_type: selectedLead?.source_type || '',
    partner_id: selectedLead?.partner_id || null,
    project_id: selectedLead?.project_id || '',
  });
  
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const sourceTypes = [
    { label: 'Partner Referral', value: 'PARTNER_REFERRAL' },
    { label: 'Social Media', value: 'SOCIAL_MEDIA' },
    { label: 'Online Ad', value: 'ONLINE_AD' },
    { label: 'Event', value: 'EVENT' },
    { label: 'Personal Network', value: 'PERSONAL_NETWORK' },
    { label: 'Other', value: 'OTHER' },
  ];

  useEffect(() => {
    dispatch(getAllPartnerUsers());
    dispatch(getAllProjects());
  }, [dispatch]);

  useEffect(() => {
    if (partnerUsers) {
      console.log('partners', partnerUsers);
      const options = partnerUsers.map((partner: any) => ({
        label: `${partner.first_name} ${partner.last_name}`,
        value: partner.id,
      }));
      setPartnerOptions(options);
    }
  }, [partnerUsers]);

  useEffect(() => {
    if (projects) {
      const options = projects.map((project: any) => ({
        label: project.name,
        value: project.id,
      }));
      setProjectOptions(options);
    }
  }, [projects]);

  useEffect(() => {
    console.log('partnerOptions', partnerOptions);
  }, [partnerOptions]);

  const handleCreateLead = async (e: React.FormEvent) => {
    try {
      setIsLoading(true);
      e.preventDefault();

      const leadData = {
        ...lead,
        partner_id: lead.source_type === 'PARTNER_REFERRAL' ? lead.partner_id : null,
      };

      await dispatch(createLead(leadData, setIsAddModalOpen));
      setLead({ 
        first_name: '', 
        last_name: '', 
        email_address: '', 
        phone_number: '', 
        source_type: '', 
        partner_id: null,
        project_id: '',
      });
      setUpdatedLead({ 
        first_name: '', 
        last_name: '', 
        email_address: '', 
        phone_number: '', 
        source_type: '', 
        partner_id: null,
        project_id: '',
      });
    } catch (error) {
      console.log('handleCreateLead error', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateLead = (e: React.FormEvent) => {
    try {
      setIsLoading(true);
      e.preventDefault();
      if (selectedLead) {
        const leadData = {
          ...updatedLead,
          partner_id: updatedLead.source_type === 'PARTNER_REFERRAL' ? updatedLead.partner_id : null,
          is_active: isActive,
          is_deleted: false,
        };

        dispatch(
          updateLead(
            selectedLead.id,
            leadData,
            () => {
              setIsEditModalOpen(false);
              const backdrop = document.querySelector('.modal-backdrop');
              if (backdrop) {
                backdrop.remove();
              }
              document.body.classList.remove('modal-open');
              document.body.style.overflow = '';
              document.body.style.paddingRight = '';
            },
          ),
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLead((prevState) => ({ ...prevState, [name]: value }));
    setUpdatedLead((prevState: any) => ({ ...prevState, [name]: value }));
  };

  const handleSourceTypeChange = (e: any) => {
    setLead((prevState) => ({ 
      ...prevState, 
      source_type: e.value,
      partner_id: e.value === 'PARTNER_REFERRAL' ? prevState.partner_id : null 
    }));
    setUpdatedLead((prevState: any) => ({ 
      ...prevState, 
      source_type: e.value,
      partner_id: e.value === 'PARTNER_REFERRAL' ? prevState.partner_id : null 
    }));
  };

  const handlePartnerChange = (e: any) => {
    setLead((prevState) => ({ ...prevState, partner_id: e.value }));
    setUpdatedLead((prevState: any) => ({ ...prevState, partner_id: e.value }));
  };

  const handleProjectChange = (e: any) => {
    setLead((prevState) => ({ ...prevState, project_id: e.value }));
    setUpdatedLead((prevState: any) => ({ ...prevState, project_id: e.value }));
  };

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (leadCreated) {
      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Lead is created successfully',
        life: 3000,
      });
      if (accessToken) {
        dispatch(getAllLeads());
      }
    }
  }, [leadCreated]);

  useEffect(() => {
    if (selectedLead) {
      setUpdatedLead({
        id: selectedLead.id,
        first_name: selectedLead.first_name,
        last_name: selectedLead.last_name,
        email_address: selectedLead.email_address,
        phone_number: selectedLead.phone_number,
        source_type: selectedLead.source_type,
        partner_id: selectedLead.partner_id,
        project_id: selectedLead.project_id,
      });
    }
  }, [selectedLead]);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (leadUpdated) {
      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Lead is updated successfully',
        life: 3000,
      });

      if (accessToken) {
        dispatch(getAllLeads());
      }
    }
  }, [leadUpdated]);

  useEffect(() => {
    if (isError) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: errorMessage || 'An error occurred',
        life: 3000,
      });
    }
  }, [isError, errorMessage]);

  return (
    <>
      <Toast ref={toast} />
      <div
        className={`modal fade ${isAddModalOpen ? 'show' : ''}`}
        id="add-lead"
        style={{ display: isAddModalOpen ? 'block' : 'none', zIndex: 1050 }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Lead</h5>
              <button
                type="button"
                className="btn-close close-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setIsAddModalOpen(false)}
              >
                <Icon.X className="react-feather-custom"></Icon.X>
              </button>
            </div>
            <div className="modal-body pt-0">
              <form onSubmit={handleCreateLead}>
                <div className="mb-3 mt-3">
                  <label className="form-label">Project</label>
                  <Dropdown
                    value={lead.project_id}
                    options={projectOptions}
                    onChange={handleProjectChange}
                    placeholder="Select a project"
                    className="w-100"
                    required
                    appendTo="self"
                    panelClassName="dropdown-panel"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="first_name"
                    value={lead.first_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="last_name"
                    value={lead.last_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email_address"
                    value={lead.email_address}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phone_number"
                    value={lead.phone_number}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Source Type</label>
                  <Dropdown
                    value={lead.source_type}
                    options={sourceTypes}
                    onChange={handleSourceTypeChange}
                    placeholder="Select a source type"
                    className="w-100"
                    required
                    appendTo="self"
                    panelClassName="dropdown-panel"
                  />
                </div>

                {lead.source_type === 'PARTNER_REFERRAL' && (
                  <div className="mb-3">
                    <label className="form-label">Partner</label>
                    <Dropdown
                      value={lead.partner_id}
                      options={partnerOptions}
                      onChange={handlePartnerChange}
                      placeholder="Select a partner"
                      className="w-100"
                      required
                      appendTo="self"
                      panelClassName="dropdown-panel"
                    />
                  </div>
                )}

                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => setIsAddModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button
                    disabled={isLoading}
                    type="submit"
                    className="btn btn-primary"
                  >
                    Add
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Edit Modal */}
      <div
        className={`modal fade ${isEditModalOpen ? 'show' : ''}`}
        id="edit-lead"
        style={{ display: isEditModalOpen ? 'block' : 'none', zIndex: 1050 }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Lead Update</h5>
              <button
                type="button"
                className="btn-close close-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setIsEditModalOpen(false)}
              >
                <Icon.X className="react-feather-custom"></Icon.X>
              </button>
            </div>
            <div className="modal-body pt-0">
              <form onSubmit={handleUpdateLead}>
                <div className="mb-3">
                  <label className="form-label">Project</label>
                  <Dropdown
                    value={updatedLead.project_id}
                    options={projectOptions}
                    onChange={handleProjectChange}
                    placeholder="Select a project"
                    className="w-100"
                    required
                    appendTo="self"
                    panelClassName="dropdown-panel"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="first_name"
                    value={updatedLead.first_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="last_name"
                    value={updatedLead.last_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email_address"
                    value={updatedLead.email_address}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phone_number"
                    value={updatedLead.phone_number}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Source Type</label>
                  <Dropdown
                    value={updatedLead.source_type}
                    options={sourceTypes}
                    onChange={handleSourceTypeChange}
                    placeholder="Select a source type"
                    className="w-100"
                    required
                    appendTo="self"
                    panelClassName="dropdown-panel"
                  />
                </div>

                {updatedLead.source_type === 'PARTNER_REFERRAL' && (
                  <div className="mb-3">
                    <label className="form-label">Partner</label>
                    <Dropdown
                      value={updatedLead.partner_id}
                      options={partnerOptions}
                      onChange={handlePartnerChange}
                      placeholder="Select a partner"
                      className="w-100"
                      required
                      appendTo="self"
                      panelClassName="dropdown-panel"
                    />
                  </div>
                )}

                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => setIsAddModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadsModal; 